import { UpdateFeatureDc } from "@evergis/api";
import { useCallback } from "react";
import { updateFeature as updateFeatureResource } from "../../resources/layers";
import { useSGisLayerRedraw } from "../sgis/useSGisLayerRedraw";
import { useSGisLayer } from "../sgis/useSGisLayers";

export const useUpdateFeature = (layerName?: string) => {
  const [mutation, { error, loading, data }] = updateFeatureResource.use();
  const sgisLayer = useSGisLayer(layerName);
  const redrawLayer = useSGisLayerRedraw(sgisLayer);

  const updateFeature = useCallback(
    async (feature: UpdateFeatureDc) => {
      if (!layerName) return;

      await mutation({
        input: {
          layerName,
          feature,
        },
      });

      redrawLayer();
    },
    [layerName, sgisLayer],
  );

  return [updateFeature, { error, loading, data }] as const;
};
